import { render, staticRenderFns } from "./alert-template.vue?vue&type=template&id=61c2e07f&scoped=true"
import script from "./alert-template.vue?vue&type=script&lang=js"
export * from "./alert-template.vue?vue&type=script&lang=js"
import style0 from "./alert-template.vue?vue&type=style&index=0&id=61c2e07f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c2e07f",
  null
  
)

export default component.exports